import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { UserState } from '@features/Auth/user.slice';

export const initialState: UserState = {
  user: {
    signedIn: false,
    id: 0,
    ebookId: 0,
    name: '',
    country: {
      name: '',
      isocode: '',
      timezone: '',
    },
    station: null,
    stations: null,
    username: '',
    password: null,
    permissions: {
      selectReturnLocation: false,
      locationMap: false,
      showOnlyCarsForOpenLocations: false,
      showOnlyCarsWithKeyboxcode: false,
      mapSelectCarReservation: false,
      mapSelectCarAgreement: false,
      showPriceTable: false,
      ignoreOpeningHours: false,
      sendAgreementExtraConfirmation: false,
      manualPayerInput: false,
      manualReturnLocationAddressAllowed: false,
      manualPickupLocationAddressAllowed: false,
      advancedCheckin: false,
      showEmailField: false,
      showCheckoutMobileNumberField: false,
      showReservationMobileNumberField: false,
      allowSelectChargedCarGroup: false,
      cdpInput: false,
      hccInput: false,
      tariffInput: false,
      voucherAccountNumberInput: false,
      voucherAmountInput: false,
      voucherReferenceInput: false,
      voucherNumberInput: false,
      licenseNumberInput: false,
      pciCreditCardInput: false,
      equipment: false,
      reservationToAgreement: false,
      carSearch: false,
      driverInsurance: false,
      checkoutCarFirst: false,
      showEstimatedPrice: false,
      reservationPayerRequired: false,
      workshopAnalysis: false,
      showDriverLicenseInputField: false,
      setForceDriverLicenseExpireCheckout: false,
      forceDriverLicenseFieldsCheckout: false,
      forceDriverBirthdateFieldCheckout: false,
      dynamicTimeCarBooking: false,
      ordererEmail: false,
      bisnodeSearchCustomer: false,
      bisnodeSearchPhoneAndZipCode: false,
      bisnodeSearchSocialSecurityNumber: false,
      bisnodeSearchRegnr: false,
      onlyEmailCheckin: false,
      invoiceTextFromPayer: false,
      allowCheckinBeforeToday: false,
      locationAdmin: false,
      payerAdmin: false,
      locationUser: false,
      connections: false,
      reservationMobileNumberRequired: false,
      reservationEmailAddressRequired: false,
      checkoutEmailAddressRequired: false,
      guaranteedCarDelivery: false,
      showManualPickupPlaceDeafultText: false,
      showRentalAgreementTextToCheckin: false,
      canDuplicateReservation: false,
      ccByOcOnly: false,
      sendPaymentLink: false,
      checkoutEmailMandatory: false,
      regNumberMandatoryForManualPayer: false,
      regNumberMandatoryForRegularPayer: false,
      reservationEmailMandatory: false,
      reservationMobileNumberMandatory: false,
      forceDriverLicenseExpireCheckout: false,
    },
    reservationEarliestInHours: 0,
    roles: [],
    firstName: null,
    lastName: null,
    email: null,
    telephone: null,
    mobileNumber: null,
    company: '',
    companyAddress: null,
    companyPostcode: null,
    companyCity: null,
    companyTelephone: null,
    companyContactPerson: null,
    socialSecurityNumber: null,
    imageUrl: '',
    facebookUrl: null,
    blogUrl: null,
    city: null,
    twitterUrl: null,
    pickupPlaceStation: null,
    pickupPlaceId: null,
    rightsHash: '',
    sign: null,
    reservationDaysOffset: 0,
    reservationDefaultTime: null,
    useNewLocations: false,
    locationId: null,
    connectionsPayerId: null,
    logoPath: null,
    locationAdmin: false,
    priceListFilename: null,
    accountActive: false,
    findStationsFromPickupPlaces: false,
    info: null,
    locale: {
      lang: '',
      country: '',
    },
  },
  error: null,
};

const profileSlice: Slice<UserState> = createSlice({
  name: 'profileState',
  initialState,
  reducers: {
    setUserProfile: (state, action: PayloadAction<UserState['user']>) => {
      state.user = { ...state.user, ...action.payload };
    },
    setPickupPlaceStation: (state, action: PayloadAction<string>) => {
      state.user.pickupPlaceStation = action.payload;
    },
  },
});

export const { setUserProfile, setPickupPlaceStation } = profileSlice.actions;
export default profileSlice.reducer;
